import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

import { XfersLogo, XfersSandboxLogo } from '@xfers/design-system/es/logos'
import { createGaEvent } from '~/helpers/gaHelper'
import Menu from './Menu'

type NavigationType = {
  isSandbox: boolean
}

export default function({ isSandbox }: NavigationType) {
  return (
    <SideContainer style={{ backgroundColor: isSandbox ? '#263a52' : 'white' }}>
      <FixedContainer>
        <LogoPanel>
          <Link
            to="/"
            onClick={() => createGaEvent('General', 'clickXfersLogoLink', 'Clicked Xfers Logo')}
          >
            {isSandbox ? (
              <XfersSandboxLogo width={180} height={22} />
            ) : (
              <XfersLogo width={100} height={32} />
            )}
          </Link>
        </LogoPanel>
        <Menu isSandbox={isSandbox} />
      </FixedContainer>
    </SideContainer>
  )
}

const SideContainer = styled.div`
  min-height: 100vh;
  width: 257px;
  flex: 1;
  flex-shrink: 0;
  display: block;

  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  width: 257px;
`

const FixedContainer = styled.div`
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  width: 257px;
  border-right: 1px solid #e8e8e8;
`

const LogoPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 35px;
`
